import { Routes } from '@angular/router';
import { LoginComponent } from './pages/auth/login/login.component';
import { InicioComponent } from './pages/inicio/inicio.component';
import { EmpresasComponent } from './pages/empresas/empresas.component';
import { LicenciasComponent } from './pages/licencias/licencias.component';
import { SedesComponent } from './pages/sedes/sedes.component';
import { UsuariosComponent } from './pages/admin/usuarios/usuarios.component';
import { authGuard, guestGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: 'auth/login',
    component: LoginComponent,
    pathMatch: 'full',
    title: 'Login',
    canActivate: [guestGuard],
  },
  {
    path: 'dashboard',
    component: InicioComponent,
    title: 'Inicio',
    canActivate: [authGuard],
  },
  {
    path: 'dashboard/empresas',
    component: EmpresasComponent,
    title: 'Empresas',
    canActivate: [authGuard],
  },
  {
    path: 'dashboard/licencias',
    component: LicenciasComponent,
    title: 'Licencias',
    canActivate: [authGuard],
  },
  {
    path: 'dashboard/empresas/:empresaId/sedes',
    component: SedesComponent,
    title: 'Sedes',
    canActivate: [authGuard],
  },
  {
    path: 'dashboard/admin/usuarios',
    component: UsuariosComponent,
    title: 'Usuarios',
    canActivate: [authGuard],
  },
  {
    path: 'dashboard/empresas/:empresaId/usuarios',
    component: UsuariosComponent,
    title: 'Usuarios por Empresa',
    canActivate: [authGuard],
  },
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: '**', redirectTo: '/dashboard' },
];
